export default {
  SHOW_AUTHORIZATION_PAGE: 605,
  EDIT_ACCOUNT_PAGE: 1344,
  KA1: process.env.VUE_APP_KA1,
  KA2: process.env.VUE_APP_KA2,
};
